export enum SITE_INTEGRATION_TYPE {
  CAFE24 = 1,
  SIXSHOP = 2,
  SHOPIFY = 3,
  NHN = 4,
  MAKESHOP = 5,
  WORDPRESS = 6,
  GODOMALL = 7,
  SIXSHOP_PRO = 8,
}

export const STA_EASY_CANVAS_DEMO_SITE_ID = "tofcyoygvx";
export const PROD_EASY_CANVAS_DEMO_SITE_ID = "lpmlsrrbht";
export const WWW_EASY_CANVAS_DEMO_TOKEN_ID = "www_easy_canvas_demo";
export const EASY_CANVAS_DEMO_SITE_IDS = [
  STA_EASY_CANVAS_DEMO_SITE_ID,
  PROD_EASY_CANVAS_DEMO_SITE_ID,
];
